import { withProps } from 'recompose';
import HomePage from './HomePage';

export default withProps({ locale: 'zh' })(HomePage);
